define([
"OTranslate",
"OUtils",
"dwr/interface/ReferralPatientEmailRpc"
], function(OTranslate, OUtils, ReferralPatientEmailRpc) {
	"use strict";

	var pane = null;

	function init(spec) {
		var referralRef = spec.referralRef || OUtils.getURLVars()["ref"] || OUtils.getURLVars()["id"];
		//check id in case of legacy emails prior to Nov 2017 (delete 2018)
		pane = $("#appPane");
		ReferralPatientEmailRpc.setBookingConfirmed(referralRef, true, function() {
			pane.find("#confirmLoader").hide();
			pane.find("#confirmDone").fadeIn();
		});
		ReferralPatientEmailRpc.getPtSurveyLink(referralRef, function(link) {
			if (link) {
				pane.find("#surveyLink").show().text(link.ptSurveyLinkText).wrap("<a href=\""+link.ptSurveyLink+"\"/>");
			}
		});
		OTranslate.translateHtml($("html"));
	}
	$(function() {
		OTranslate.i18nInitTest({ namespaces: ["pn-pe"] }, function() {
			init({});
		});
	})
	return {
		init: init
	};
});